module.exports = __webpack_public_path__ + "img/delete-outline.0ef1f971.svg";